import useMapExpansionStore from "@/store/useMapExpansionStore";
import type { SpecialLocation } from "@/types/specialLocations";
import Phaser from "phaser";

const config: Array<SpecialLocation> = [
	{
		coordinates: { x: 493, y: 472 },
	},
	{
		coordinates: { x: 499, y: 581 },
	},
	{
		coordinates: { x: 566, y: 386 },
	},
	{
		coordinates: { x: 629, y: 620 },
	},
	{
		coordinates: { x: 527, y: 627 },
	},
	{
		coordinates: { x: 500, y: 458 },
	},
	{
		coordinates: { x: 497, y: 404 },
	},
	{
		coordinates: { x: 566, y: 509 },
	},
	{
		coordinates: { x: 553, y: 560 },
	},
	{
		coordinates: { x: 507, y: 542 },
	},
	{
		coordinates: { x: 441, y: 587 },
	},
	{
		coordinates: { x: 533, y: 461 },
	},
	{
		coordinates: { x: 503, y: 494 },
	},
	{
		coordinates: { x: 515, y: 520 },
	},
	{
		coordinates: { x: 491, y: 578 },
	},
	{
		coordinates: { x: 583, y: 503 },
	},
	{
		coordinates: { x: 390, y: 542 },
	},
	{
		coordinates: { x: 527, y: 496 },
	},
	{
		coordinates: { x: 423, y: 461 },
	},
	{
		coordinates: { x: 397, y: 622 },
	},
	{
		coordinates: { x: 610, y: 399 },
	},
	{
		coordinates: { x: 623, y: 545 },
	},
	{
		coordinates: { x: 445, y: 388 },
	},
	{
		coordinates: { x: 493, y: 391 },
	},
	{
		coordinates: { x: 626, y: 459 },
	},
	{
		coordinates: { x: 632, y: 575 },
	},
	{
		coordinates: { x: 535, y: 631 },
	},
	{
		coordinates: { x: 427, y: 625 },
	},
	{
		coordinates: { x: 388, y: 558 },
	},
	{
		coordinates: { x: 456, y: 535 },
	},
	{
		coordinates: { x: 387, y: 457 },
	},
	{
		coordinates: { x: 435, y: 392 },
	},
	{
		coordinates: { x: 631, y: 405 },
	},
	{
		coordinates: { x: 411, y: 629 },
	},
	{
		coordinates: { x: 580, y: 628 },
	},
	{
		coordinates: { x: 499, y: 568 },
	},
	{
		coordinates: { x: 581, y: 411 },
	},
	{
		coordinates: { x: 541, y: 598 },
	},
	{
		coordinates: { x: 424, y: 571 },
	},
	{
		coordinates: { x: 398, y: 578 },
	},
	{
		coordinates: { x: 464, y: 628 },
	},
	{
		coordinates: { x: 409, y: 387 },
	},
	{
		coordinates: { x: 524, y: 386 },
	},
	{
		coordinates: { x: 525, y: 416 },
	},
	{
		coordinates: { x: 610, y: 414 },
	},
	{
		coordinates: { x: 398, y: 477 },
	},
	{
		coordinates: { x: 516, y: 505 },
	},
	{
		coordinates: { x: 390, y: 547 },
	},
	{
		coordinates: { x: 519, y: 557 },
	},
	{
		coordinates: { x: 624, y: 568 },
	},
	{
		coordinates: { x: 579, y: 630 },
	},
	{
		coordinates: { x: 500, y: 633 },
	},
	{
		coordinates: { x: 580, y: 481 },
	},
	{
		coordinates: { x: 348, y: 619 },
	},
	{
		coordinates: { x: 675, y: 364 },
	},
	{
		coordinates: { x: 344, y: 625 },
	},
	{
		coordinates: { x: 354, y: 374 },
	},
	{
		coordinates: { x: 669, y: 456 },
	},
	{
		coordinates: { x: 663, y: 530 },
	},
	{
		coordinates: { x: 335, y: 411 },
	},
	{
		coordinates: { x: 662, y: 655 },
	},
	{
		coordinates: { x: 670, y: 363 },
	},
].map(
	(
		e: { coordinates: { x: number; y: number } },
		index: number,
	): SpecialLocation => ({
		key: index,
		distance: Phaser.Math.Distance.Between(
			512,
			512,
			e.coordinates.x,
			e.coordinates.y,
		),
		coordinates: e.coordinates,
	}),
);

export const getSpecialLocationConfigById = (
	id: number,
): SpecialLocation | null => {
	if (!config[id]) return null;
	return config[id];
};

export const getSpecialLocationsOrderedByDistance =
	(): Array<SpecialLocation> => {
		const { minX, maxX, minY, maxY } =
			useMapExpansionStore().getEffectiveMapBorderCoordinates();

		return Object.values(config)
			.filter(
				({ coordinates: { x, y } }: SpecialLocation): boolean =>
					x >= minX && x <= maxX && y >= minY && y <= maxY,
			)
			.sort(
				(a: SpecialLocation, b: SpecialLocation): number =>
					a.distance - b.distance,
			);
	};
